module.exports = __webpack_public_path__ + "735c87be65bc32e29993ffb720df8b94.svg";